// Libs
import classNames from 'classnames/bind';
import { useState } from 'react';
import { Stack } from '@mui/material';
// Components, Layouts, Pages
import { JobKanban, JobList } from '~/components/module/job';
// Others
import { PageEnum } from '~/utils/enum/common';
// Styles, images, icons
import styles from './Jobs.module.scss';

const cx = classNames.bind(styles);

const Jobs = () => {
  //#region Destructuring Props
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [isTypePage, setIsTypePage] = useState<string>(PageEnum.LIST);
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const handleOnChangeType = (value: string) => {
    setIsTypePage(value);
  };
  //#endregion Handle Function

  return (
    <Stack id='jobPage' className={cx('container')}>
      {isTypePage === PageEnum.KANBAN ? (
        <JobKanban isTypePage={isTypePage} onChangeType={handleOnChangeType} />
      ) : (
        <JobList isTypePage={isTypePage} onChangeType={handleOnChangeType} />
      )}
    </Stack>
  );
};

export default Jobs;
